import { AccordionItem, List, Stack, Text } from 'braid-design-system';
export const Implementation = () => (
  <AccordionItem id="implementation" label="Implementation">
    <List type="number" start={9}>
      <Stack space="medium">
        <Text>
          In the event that we consent to your integration with the SEEK API,
          you agree to work collaboratively with us to undertake such
          integration including to:
        </Text>
        <List type="alpha">
          <Text>
            provide us with an in-system demo overview of your current
            integrations with us (if applicable);
          </Text>
          <Text>
            complete system integration and/or integration verification testing
            of all required test cases; and
          </Text>
          <Text>
            provide visibility of your SEEK API integrations for the purpose of
            system integration and/or integration verification testing
            activities.
          </Text>
        </List>
      </Stack>
    </List>
  </AccordionItem>
);
